<ng-container>
  @if (showHeaderFooter$ | async) {
    <dl-header></dl-header>
  }
  <router-outlet></router-outlet>
  @if (showHeaderFooter$ | async) {
    <dl-footer></dl-footer>
  }
</ng-container>

<div *ngIf="loadingService.loading$ | async" class="loading-overlay">
  <owc-progress-spinner mode="indeterminate" size="xxLarge" variant="primary"></owc-progress-spinner>
</div>
